import React, { useCallback, useEffect, useState } from "react";
import { Grid, Box, Button } from '@mui/material';
import AxiosInstance from "../../../server/AxioInstance";
import { useSnackbar } from '../../../shared/context';
import MultiSelectAutocomplete from "../../common/autoComplete/MultiSelectAutocomplete";

const CoachRegistre = ({ handleChangeComponent,}) => {
    const [getOptionsUser, setOptionsUser] = useState([]);
    const { showSnackbar } = useSnackbar();
    const [formData, setFormData] = useState({
        coach: [],
        user_login: localStorage.getItem('@gedy:user'),
    });
    
    const handleReturnComponent = () => {
        handleChangeComponent('Consultar usuários que podem criar treinamentos.','consult');
    }

    const handleChange = (e, value) => {
        setFormData((prevData) => ({ ...prevData, coach: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault(); 

        try {
            const result = await AxiosInstance.post('/training/create-coach', formData);
            showSnackbar({
                vertical: 'top',
                horizontal: 'right',
                message: result.data,
                variant: 'success',
            });
            // handleReturnComponent();
        } catch (error) {
            showSnackbar({
                vertical: 'top',
                horizontal: 'right',
                message: 'Erro ao enviar a requisição: ' + error.message,
                variant: 'error',
            });
        }
    }

    const getUsersNotCoach = useCallback(async ()=>{
        const result = await AxiosInstance.get('/data-input//users-not-coach');
        setOptionsUser(result.data);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        getUsersNotCoach();
    }, [getUsersNotCoach]);
    

    return(
        <Box m={1}>
            <form onSubmit={handleSubmit} method='POST'>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={12} xl={12}>
                        <MultiSelectAutocomplete 
                            value={formData.coach}
                            options={getOptionsUser} 
                            label='Selecione os usuários'
                            onChange={(event, selectValues) => handleChange(event, selectValues)}
                            required={false}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} xl={6}>
                        <Button 
                            variant='contained' 
                            color="primary"
                            onClick={handleReturnComponent}
                            fullWidth
                        >
                            voltar
                        </Button>
                    </Grid>
                    <Grid item xs={12} md={6} xl={6}>
                        <Button 
                            type='submit'  // Adicionando o tipo submit ao botão
                            variant='contained' 
                            color="success"
                            fullWidth
                        >
                            cadastrar
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Box>
    )
}

export default CoachRegistre;